const SAFEMODE_STAUS = {
    RED: 'RED',
    GREEN: 'GREEN',
};

const ROW_COUNTRY_CODE = 'ROW';
const GCP_FIREDRILL_COUNTRY_CODE = 'TEST';

export { SAFEMODE_STAUS, ROW_COUNTRY_CODE, GCP_FIREDRILL_COUNTRY_CODE };
